const initialState = [];
//
export default function cm0005(state = initialState, action) {
  switch (action.type) {
    case 'SET_CM0005':
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    case 'SET_CM0005_ERROR':
      return state;
    default:
      return state;
  }
}
